import Store from "../../../../Store/Store";

class PaymentTypeContainer {
  public getInstances() {
    const paymentTypes = Store.getConfigurator().getState().globalTypes?.PaymentType;

    if (!paymentTypes) {
      return;
    }

    const instances = [];

    for(const type in paymentTypes) {
      if (paymentTypes[type].id) {
        instances.push(paymentTypes[type])
      }
    }
    return instances;
  }

  public pickIdFromLabel(label) {
    const paymentTypes = Store.getConfigurator().getState().globalTypes?.PaymentType;

    if (!paymentTypes) {
      return;
    }

    for (const type in paymentTypes) {
      if (paymentTypes[type].label?.toLowerCase() === label?.toLowerCase()) {
        return paymentTypes[type].id
      }
    }
  }
}

export default new PaymentTypeContainer();
